<template>
    <section>
        <perfect-scrollbar class="mt-4">
            <table>
                <thead>
                    <tr>
                        <th>รายการสต๊อค</th>
                        <th class="text-center">จำนวนสต๊อค</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>คงเหลือ (ของร้าน)</td>
                        <td class="text-center">{{ $AppUtility.getAvailableStock(contentData.stockData, 'amountNormal') }}</td>
                    </tr>
                    <tr>
                        <td>คงเหลือ (สินค้าโป๊ว)</td>
                        <td class="text-center">{{ $AppUtility.getAvailableStock(contentData.stockData, 'amountSublet') }}</td>
                    </tr>
                    <tr>
                        <td>คงเหลือ (ฝากขาย)</td>
                        <td class="text-center">{{ $AppUtility.getAvailableStock(contentData.stockData, 'amountConsign') }}</td>
                    </tr>
                    <tr>
                        <td>ถูกจองไว้</td>
                        <td class="text-center">{{ contentData.stockData.reserve }}</td>
                    </tr>
                </tbody>
            </table>
        </perfect-scrollbar>

        <div class="mt-5 stock-title">
            <h3><b-icon icon="folder2-open"></b-icon> ปรับสต๊อค</h3>
        </div>
        
        <div class="stock-adjust mt-2" v-if="formData && errorData">
            <div class="dot-remain" v-if="formData.dot && !isNewDot">
                <perfect-scrollbar>
                    <table>
                        <thead>
                            <tr>
                                <th>สัปดาห์ยาง</th>
                                <th class="text-center">ของร้าน</th>
                                <th class="text-center">สินค้าโป๊ว</th>
                                <th class="text-center">ฝากขาย</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ formData.dot }}</td>
                                <td class="text-center">{{ contentData.stockData.dots.find(x => x.name === formData.dot).amountNormal }}</td>
                                <td class="text-center">{{ contentData.stockData.dots.find(x => x.name === formData.dot).amountSublet }}</td>
                                <td class="text-center">{{ contentData.stockData.dots.find(x => x.name === formData.dot).amountConsign }}</td>
                            </tr>
                        </tbody>
                    </table>
                </perfect-scrollbar>
            </div>
            <div class="new-dot" v-if="formData.dot && isNewDot">
                สัปดาห์ยางใหม่
            </div>

            <div class="form">
                <div class="row">
                    <div class="col col-12 col-sm-4">
                        <div class="input">
                            <div class="blocking" v-if="isNewDot"></div>
                            <label>เพิ่ม/ลด</label>
                            <dropdown
                                v-model="formData.operand"
                                placeholder="เพิ่ม/ลด"
                                @change="changeOperandStock($event)"
                                :options="option.operand"
                                :classes="{ input: ['input-field', (errorData.operand.blank ? 'invalid' : '')] }"
                            ></dropdown>
                        </div>
                    </div>
                    <div class="col col-12 col-sm-4">
                        <div class="input">
                            <label>จำนวนเพิ่ม/ลด</label>
                            <input type="tel"
                                v-model="formData.amount"
                                maxlength="4"
                                class="input-field"
                                :class="{ 'invalid': errorData.amount.blank }"
                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                placeholder="จำนวน" />
                        </div>
                    </div>
                </div>
                <div class="row justify-content-end">
                    <div class="col col-12">
                        <div class="input">
                            <div class="blocking" v-if="formData.operand !== appStock.operandAction().increase"></div>
                            <label>รับสินค้ามาจาก</label>
                            <dropdown
                                v-model="formData.supplier"
                                placeholder="รับสินค้ามาจาก"
                                :disabled="fixSupplier"
                                :options="option.supplier"
                                :classes="{ input: ['input-field', (errorData.supplier.blank ? 'invalid' : '')] }"
                            ></dropdown>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-12 col-sm-4">
                        <div class="input">
                            <div class="blocking" v-if="contentData.productData.productCategory !== this.$Constants.CATEGORY_TIRE"></div>
                            <label>สัปดาห์ยาง</label>
                            <input-dot
                                v-model="formData.dot"
                                @change="changeTireDot($event)"
                                class="input-component"
                                :inputClass="[ 'input-field' ]"
                                placeholder="สัปดาห์ยาง">
                            </input-dot>
                        </div>
                    </div>
                    <div class="col col-12 col-sm-4">
                        <div class="input">
                            <div class="blocking" v-if="isConsignment"></div>
                            <label>ประเภทสต๊อค</label>
                            <dropdown
                                v-model="formData.type"
                                placeholder="ประเภทสต๊อค"
                                :options="option.stockType"
                                :classes="{ input: ['input-field', (errorData.type.blank ? 'invalid' : '')] }"
                            ></dropdown>
                        </div>
                    </div>
                    <div class="col col-12 col-sm-4">
                        <div class="input">
                            <div class="blocking" v-if="formData.operand !== appStock.operandAction().increase"></div>
                            <label>ต้นทุนเฉลี่ย</label>
                            <input type="tel"
                                v-model="formData.cost"
                                maxlength="8"
                                class="input-field"
                                :class="{ 'invalid': errorData.cost.blank }"
                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                placeholder="ต้นทุนเฉลี่ย" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="action mt-3 text-right">
                <button class="btn btn-secondary" @click="adjustStock()">บันทึก</button>
            </div>
        </div>
    </section>
</template>

<script>
import Helper from '@/resources/Helper';
import ModelStockHistoryData from '@/resources/models/StockHistoryData';
import ModelAccountingData from '@/resources/models/AccountingData';
import ModelStockSyncData from '@/resources/models/StockSyncData';
import OptionOperandStock from '@/database/staticOption/OperandStock';
import OptionStockType from '@/database/staticOption/StockType';
import DBAccounting from '@/database/Accounting';
import DBEngine from '@/database/_Base';
import DBStock from '@/database/Stock';
import DBStockHistory from '@/database/StockHistory';
import DBInventory from '@/database/Inventory';
import DBSupplier from '@/database/Supplier';

export default {
    data() {
        return {
            isNewDot: false,
            isConsignment: false,
            formData: null,
            errorData: null,
            appStock: DBStock,
            option: {
                operand: [],
                stockType: [],
                supplier: []
            }
        };
    },
    props: {
        contentData: Object,
        fixSupplier: String
    },
    async mounted() {
        this.formData = await this.initFormStock();
        this.errorData = this.initValidateStock();

        if (this.fixSupplier) {
            this.formData.supplier = this.fixSupplier;
        }
    },
    methods: {
        async initFormStock() {
            this.isConsignment = this.checkConsignmentStock();
            this.option.operand = OptionOperandStock.option;
            this.option.stockType = this.getStockTypeOption();
            this.option.supplier = await this.getSupplierOption();

            const formData = ModelStockSyncData.data();

            formData.key = this.contentData.key;
            formData.type = this.isConsignment ? DBStock.stockType().consign : DBStock.stockType().normal;
            formData.operand = DBStock.operandAction().increase;

            return formData;
        },
        initValidateStock() {
            return {
                type: { blank: false },
                operand: { blank: false },
                amount: { blank: false },
                cost: { blank: false },
                supplier: { blank: false }
            };
        },
        checkConsignmentStock() {
            if (this.contentData.stockData.dots.filter(x => x.amountConsign > 0).length > 0) {
                return true;
            }

            return false;
        },
        changeOperandStock(value) {
            if (value !== DBStock.operandAction().increase) {
                this.formData.cost = '';
            }
        },
        changeTireDot(value) {
            let isNewDot = false;

            if (value !== '') {
                if (this.contentData.stockData.dots.filter(x => x.name === value).length === 0) {
                    isNewDot = true;
                    this.formData.operand = DBStock.operandAction().increase;
                }
            }

            this.isNewDot = isNewDot;
        },
        async adjustStock() {
            if (this.validateData()) {
                // Loader
                const loader = this.$AppUtility.renderLoadBackdrop();

                // Save Stock Update
                const stockUpdate = await this.saveStockUpdate();

                // Keep History
                await this.saveStockHistory(stockUpdate.adjustAmount);
                let history = await DBStockHistory.getHistoryByInventory(this.contentData.key);
                
                if (this.formData.operand === DBStock.operandAction().increase) {
                    // Add Accounting Journal
                    await this.saveAccounting(stockUpdate.adjustAmount);
                } else if (this.formData.operand === DBStock.operandAction().decrease) {
                    // Clear Cost Average if Zero Stock
                    if (!this.$AppUtility.isAnyStockAvailable(stockUpdate.data)) {
                        history = await this.$AppUtility.clearCostCounterHistory(this.contentData.key, history);
                    }
                }

                // Calculate Average Cost
                const costAverage = await this.$AppUtility.calculateAverageCost(history);

                // Save Inventory Data
                await this.saveInventory(costAverage);

                // Return Update to Parent Component
                this.$emit('stockUpdate', stockUpdate.data);

                // Reset Form
                this.formData = this.initFormStock();
                this.errorData = this.initValidateStock();

                // Display Complete
                loader.hide();
                
                this.$swal({
                    title: 'ปรับจำนวนสต๊อคเรียบร้อยแล้ว',
                    icon: 'success'
                });
            }
        },
        async saveStockUpdate() {
            const stockUpdate = await this.setupUpdateStockData();

            await DBStock.save(stockUpdate.data, this.formData, DBEngine.syncAction().adjuststock);

            return stockUpdate;
        },
        async saveStockHistory(adjustAmount) {
            const stockHistory = this.setupStockHistory(adjustAmount);

            await DBStockHistory.save(stockHistory);
        },
        async saveInventory(costAverage) {
            const data = {
                key: this.contentData.key,
                productData: this.contentData.productData,
                inventoryData: this.contentData.inventoryData
            };

            data.inventoryData.cost = costAverage;

            await DBInventory.save(data);
        },
        async saveAccounting(adjustAmount) {
            const syncData = ModelAccountingData.data();
            const totalPrice = parseFloat(this.formData.cost) * adjustAmount;
            const title = this.setupAccountingJournalTitle(adjustAmount);

            syncData.date = new Date();
            syncData.title = title
            syncData.expense = totalPrice;
            syncData.bookNumber = 1;
            syncData.isClonable = true;

            await DBAccounting.save(syncData);
        },
        setupAccountingJournalTitle(adjustAmount) {
            let title = 'นำเข้าสต๊อคสินค้า ';

            switch (this.formData.type) {
                case DBStock.stockType().sublet:
                    title = title + '(สินค้าโป๊ว) ';
                    break;

                case DBStock.stockType().consign:
                    title = title + '(สินค้าฝากขาย) ';
                    break;
            }

            title = title + '"SKU: ' + this.contentData.inventoryData.sku + ' - ' + this.contentData.productData.name + '" จำนวน ' + adjustAmount + ' ชิ้น โดยต้นทุนเฉลี่ย ' + Helper.getCommaNumber(this.formData.cost) + ' นำเข้าจาก "' + this.formData.supplier + '"';

            return title;
        },
        async setupUpdateStockData() {
            const typeProperty = this.getStockTypeProperty();
            let stockData = await DBStock.getDetail(this.formData.key);
            let adjustAmount = parseInt(this.formData.amount);

            if (!this.isNewDot || !this.formData.dot) {
                // Dot Exist
                const dotIndex = stockData.dots.findIndex(x => x.name === this.formData.dot || (!x.name && !this.formData.dot));
                const currentAmount = stockData.dots[dotIndex][typeProperty];
                let adjustAmount = parseInt(this.formData.amount);

                switch (this.formData.operand) {
                    case DBStock.operandAction().increase:
                        stockData.dots[dotIndex][typeProperty] += adjustAmount;
                        break;

                    case DBStock.operandAction().decrease:
                        // Prevent Stock Less Than 0
                        if (currentAmount < adjustAmount) {
                            adjustAmount = currentAmount;
                        }
                        
                        stockData.dots[dotIndex][typeProperty] -= adjustAmount;

                        break;
                }
            } else {
                // New Dot
                stockData.dots.push({
                    name: this.formData.dot,
                    amountNormal: typeProperty === 'amountNormal' ? adjustAmount : 0,
                    amountSublet: typeProperty === 'amountSublet' ? adjustAmount : 0,
                    amountConsign: typeProperty === 'amountConsign' ? adjustAmount : 0
                });
            }
            
            return {
                data: stockData,
                adjustAmount: adjustAmount
            };
        },
        setupStockHistory(adjustAmount) {
            const history = ModelStockHistoryData.data();

            history.inventoryKey = this.contentData.key;
            history.type = this.formData.type;
            history.dot = this.formData.dot;
            history.operand = this.formData.operand;
            history.adjustAmount = adjustAmount;
            history.averageCost = this.formData.operand === DBStock.operandAction().increase ? parseFloat(this.formData.cost) : 0;
            history.supplier = this.formData.supplier;
            history.isCountAverage = this.formData.operand === DBStock.operandAction().increase ? true : false;
            history.updateAt = Helper.getClientTime();
            
            return history;
        },
        getStockTypeOption() {
            let option = OptionStockType.option;

            if (this.isConsignment) {
                option = option.filter(x => x.id === DBStock.stockType().consign);
            } else {
                if (this.$AppUtility.isAnyStockAvailable(this.contentData.stockData)) {
                    option = option.filter(x => x.id !== DBStock.stockType().consign);
                }
            }

            return option;
        },
        async getSupplierOption() {
            const result = await DBSupplier.get();
            const option = [];

            if (result.content && result.content.length > 0) {
                result.content.forEach((item) => {
                    option.push({ id: item.name, name: item.name });
                });
            }

            return option;
        },
        getStockTypeProperty() {
            let property = '';

            switch (this.formData.type) {
                case DBStock.stockType().normal:
                    property = 'amountNormal';
                    break;

                case DBStock.stockType().sublet:
                    property = 'amountSublet';
                    break;

                case DBStock.stockType().consign:
                    property = 'amountConsign';
                    break;
            }

            return property;
        },
        validateData() {
            this.errorData = this.initValidateStock();
            let valid = true;
            
            if (!this.formData['type'].trim()) {
                this.errorData['type'].blank = true;
                valid = false;
            }
            if (!this.formData['operand'].trim()) {
                this.errorData['operand'].blank = true;
                valid = false;
            }
            if (!this.formData['amount'].trim()) {
                this.errorData['amount'].blank = true;
                valid = false;
            }
            if (this.formData.operand === DBStock.operandAction().increase) {
                if (!this.formData['cost'].trim()) {
                    this.errorData['cost'].blank = true;
                    valid = false;
                }
                if (!this.formData['supplier'].trim()) {
                    this.errorData['supplier'].blank = true;
                    valid = false;
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/inventory/modalStock/StockContent.scss';
</style>